import { render, staticRenderFns } from "./NavigationPagev1.vue?vue&type=template&id=d5f1c5a4&scoped=true&"
import script from "./NavigationPagev1.vue?vue&type=script&lang=js&"
export * from "./NavigationPagev1.vue?vue&type=script&lang=js&"
import style0 from "./NavigationPagev1.vue?vue&type=style&index=0&id=d5f1c5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f1c5a4",
  null
  
)

export default component.exports